import { environment } from '@/config'

export const IS_TEST_ENVIRONMENT = environment !== 'production'
export const HEADER_COLOR = IS_TEST_ENVIRONMENT ? 'red' : 'primary'
